import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Link } from "react-router-dom";

const Banking = () => {
  const navigate = useNavigate();
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
    const [bankSettingData, setBankSettingData] = useState([]);

  useEffect(() => {
    // Fetch banners from API on component mount
    const fetchBankSettingData = async () => {
      try {
        const response = await axios.get("https://api.trubetx.com/admin/getBankDetails?payment_type=bank",
            {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
        ); // adjust base URL if needed
        console.log(response.data);
        setBankSettingData(response.data);
      } catch (err) {
        console.error("Failed to fetch banners:", err);
        setError("Failed to load banners.");
      } finally {
        setLoading(false);
      }
    };

    fetchBankSettingData();
  }, []);

   const updateBank = (id) => {
   
    navigate(`/banking/create/upi/edit/${id}`);
  };

 

  return (
     <main className="flex ml-0 lg:ml-[230px]  overflow-auto bg-stone-100 pb-8">
        <div className="w-full flex-1 px-5">
            <div className="my-5">
            <div className="flex items-center justify-between">
                <div className="w-auto">
                <h1 className="font mb-3 flex flex-wrap items-center text-lg font-bold text-stone-800 md:text-xl">
                    Website Banking Details{" "}
                </h1>
                </div>
                <div className="w-auto">
                <div className="flex gap-2">
                    <div className="flex items-center gap-2 ">
                    <Link to="/banking/create/upi">
                        <button
                        className="bg-[#228be6] text-white h-[2.25rem] px-4 rounded-lg"
                        type="button"
                        data-button="true"
                        >
                        <div className="mantine-1wpc1xj mantine-Button-inner">
                            <span className="mantine-1ryt1ht mantine-Button-label">
                            Create
                            </span>
                        </div>
                        </button>
                    </Link>
                    </div>
                </div>
                </div>
            </div>
            <div className="flex items-center gap-2">
                <a className="font-semibold text-cm-gray" href="/web/banking#">
                Web<span className="ml-2">/</span>
                </a>
                <a className="font-semibold text-cm-gray" href="/web/banking#">
                Banking
                </a>
            </div>
            </div>
            <div className="relative  w-full  overflow-auto rounded-lg  bg-white shadow  ">
            <div className="relative overflow-auto   bg-gray-50">
                <table
                className="mantine-Table-root w-full min-w-max rounded-lg mantine-1mitp60"
                data-hover="true"
                >
                <thead className="w-full bg-white uppercase ">
                    <tr className=" ">
                    <th scope="col" className="px-6 py-3  ">
                        ACCOUNT NAME
                    </th>
                    <th scope="col" className="px-6 py-3  ">
                        ACCOUNT NUMBER
                    </th>
                    <th scope="col" className="px-6 py-3  ">
                        BANK NAME
                    </th>
                    <th scope="col" className="px-6 py-3  ">
                        IFSC CODE
                    </th>
                    <th scope="col" className="px-6 py-3  ">
                        UPI ID
                    </th>
                    <th scope="col" className="px-6 py-3  ">
                       QR{" "}
                    </th>
                    <th scope="col" className="px-6 py-3  ">
                        UPDATE
                    </th>
                    <th scope="col" className="px-6 py-3  ">
                        Action
                    </th>
                    </tr>
                </thead>
                <tbody className="text-center">
                    {
                        bankSettingData?.data?.map((item, index) => (
                            <tr key={index} className="border-b">
                                <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                    {item.account_holder_name}
                                </td>
                                <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                    {item.account_number}
                                </td>
                                <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                    {item.bank_name}
                                </td>
                                <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                    {item.ifsc_code}
                                </td>
                                <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                    {item.upi_id}
                                </td>
                                <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                     <div className="flex flex-col items-center justify-center">
                                    <img
                                        src={
                                        item?.qr_img?.startsWith("data:image")
                                            ? item.qr_img // Show selected image preview
                                            : `https://api.trubetx.com/uploads/QrCodes/${item.qr_img}`
                                        } // Show stored image
                                        alt="QR Code"
                                        className="w-36 h-36 object-contain border p-2 border-gray-700 rounded-lg"
                                    />
                                    </div>
                                </td>
                                <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                    <button
                                        onClick={() => updateBank(item?.id)}
                                        className="text-blue-600 hover:underline"
                                    >
                                        Update
                                    </button>
                                </td>
                                <td>
                                <label
                                    htmlFor={`is-active-${item.id}`}
                                    className="relative inline-block w-11 h-6 cursor-pointer"
                                >
                                    <input
                                    type="checkbox"
                                    id={`is-active-${item.id}`}
                                    className="peer sr-only"
                                    checked={item.isactive} // ✅ Controlled input
                                   
                                    />
                                    <span className="absolute inset-0 bg-gray-200 rounded-full transition-colors duration-200 ease-in-out peer-checked:bg-blue-600 dark:bg-neutral-700 dark:peer-checked:bg-blue-500 peer-disabled:opacity-50 peer-disabled:pointer-events-none" />
                                    <span className="absolute top-1/2 start-0.5 -translate-y-1/2 size-5 bg-white rounded-full shadow-xs transition-transform duration-200 ease-in-out peer-checked:translate-x-full dark:bg-neutral-400 dark:peer-checked:bg-white" />
                                </label>
                                </td>

                            </tr>
                        ))
                    }
                   
                </tbody>
                </table>
            </div>
            
            </div>
        </div>
    </main>
  );
};

export default Banking;
